var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "45ad0acfa1fca9c026e1278c2d958b70ced1e5f6"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["percko@percko"] = {
  id: "45ad0acfa1fca9c026e1278c2d958b70ced1e5f6"
};